import { render, staticRenderFns } from "./CoverImageUpload.vue?vue&type=template&id=63229253&scoped=true"
import script from "./CoverImageUpload.vue?vue&type=script&lang=js"
export * from "./CoverImageUpload.vue?vue&type=script&lang=js"
import style0 from "./CoverImageUpload.vue?vue&type=style&index=0&id=63229253&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63229253",
  null
  
)

export default component.exports